import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { InvestmentStrategyNotFound } from '../../Shared/InvestmentStrategyNotFound';

import { InvestmentStrategyListEmptyDesktop } from './Desktop';
import { InvestmentStrategyListEmptyMobile } from './Mobile';
import { InvestmentStrategyListEmptyTablet } from './Tablet';
import { InvestmentStrategyListEmptyTypes } from './types';

export const InvestmentStrategyListEmpty: React.FC<InvestmentStrategyListEmptyTypes.Props> = (
  props
) => {
  const component = useBreakpointValue({
    base: <InvestmentStrategyListEmptyMobile {...props} />,
    sm: <InvestmentStrategyListEmptyTablet {...props} />,
    lg: <InvestmentStrategyListEmptyDesktop {...props} />,
  });

  if (!props.isLoading) {
    return <InvestmentStrategyNotFound />;
  }

  return component;
};
